import { MultiPurposeParagraph } from "@/components/Atoms/Paragraph";
import { TextCopyCard } from "@/components/Molecules/CopyCard";
import { FullBackgroundImage } from "@/components/Molecules/ImageCard";
import { VideoCard } from "@/components/Molecules/VideoCard";
import { cn, string_to_slug, variantsFull } from "@/lib/functions";
import { LazyMotion, domAnimation, m } from "framer-motion";
import { useState } from "react";
import { Shape } from "@/components/Atoms/Spacer";
import React from "react";
import { TextImageProps } from "types/types";
import {
  getTextImageLabel,
  getTextImageLabelColor,
} from "./textImageLabel";

interface TextImageFullProps {
  data: TextImageProps;
}

export default function TextImageFull({ data }: TextImageFullProps) {
  const [playing, setPlaying] = useState(false);
  const imageLabel = getTextImageLabel(data);
  const imageLabelColor = getTextImageLabelColor(data);

  const togglePlay = () => {
    setPlaying(!playing);
  };

  return (
    <>
      {" "}
      {data.addSpacer && (
        <Shape
          shape={data.spacerConfiguration?.customShape}
          color={data.bgColor}
          direction={data.spacerConfiguration?.spacerDirection}
          position={
            data.spacerConfiguration?.spacerPosition === "invert"
              ? undefined
              : data.spacerConfiguration?.spacerPosition || "bottom"
          }
          icon={[
            data.spacerConfiguration?.addIconElement,
            data?.spacerConfiguration?.spacerIcon,
          ]}
          iconPosition={data.spacerConfiguration?.iconPosition}
          invert={false}
        />
      )}
      <div
        style={{ backgroundColor: data?.bgColor?.color?.hex }}
        className={`${data.useExtraTopMargins ? "pt-24" : ""} relative w-full`}
      >
        <div className="container mx-auto">
          <div
            className={`max-w-[1360px] flex ${
              data.copyPlacement == "first" ? "flex-col-reverse " : " flex-col"
            }   gap-4 lg:gap-12  relative mx-auto w-full   ${
              data.useExtraPadding ? "pt-12 pb-32" : "py-8 md:py-20 "
            } `}
          >
            <div
              className={` relative ${
                data.textAlignment === "center"
                  ? " items-center"
                  : data.textAlignment === "left"
                  ? " items-start"
                  : data.textAlignment === "right"
                  ? " items-end"
                  : "items-center text-center"
              } order-2  flex flex-col ${
                data?.imagePosition === "contain" ? "mt-12" : ""
              } `}
            >
              <TextCopyCard
                layout={data.textAlignment}
                placeEnd={data.placeTitleEndOfContent}
                data={data}
              />
              <div
                className="absolute top-[-100px]"
                id={data.title ? string_to_slug(data.title) : ""}
              ></div>
            </div>

            <div
              className={cn(
                "relative order-1 flex w-full flex-col justify-center",
                data.showLabel && imageLabel && "gap-2"
              )}
            >
              <div
                className={
                  data.contentBorderRadius === "rounded"
                    ? "overflow-hidden rounded-lg"
                    : ""
                }
              >
              {data.image?.video ? (
                <LazyMotion features={domAnimation}>
                  <m.div
                    className="relative"
                    variants={variantsFull()}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    exit="exit"
                  >
                    <VideoCard
                      onClick={() => togglePlay()}
                      color={data.fontColor?.color?.hex}
                      controls={[
                        String(data.loop || false),
                        String(data.muted || false),
                        String(data.controls || false),
                        String(data.videoPreview || false),
                        String(data.autoplay || false),
                      ]}
                      file={data.image.video}
                      className=" cursor-pointer object-cover object-bottom h-full"
                      placement={data.__typename}
                    />
                  </m.div>
                </LazyMotion>
              ) : (
                <div
                  className={`relative w-full  `}
                >
                  <LazyMotion features={domAnimation}>
                    <m.div
                      className="top-0 w-full h-full  "
                      variants={variantsFull()}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true }}
                      exit="exit"
                    >
                      <FullBackgroundImage
                        className="object-center"
                        data={data.image}
                        position={data?.imagePosition}
                      />
                    </m.div>
                  </LazyMotion>
                </div>
              )}
              </div>
              {data.showLabel && imageLabel && (
                <div className="w-full shrink-0">
                  <MultiPurposeParagraph
                    type="image"
                    color={imageLabelColor}
                    data={imageLabel}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
